
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


export default {
name: 'sbxx',
data() {
return {
data: {
extname: '',
sn: '',
seq: ''
},
flag: true,
state: '未绑定',
status: '',
statusflag: false
}
},
components: {
XHeader,
XInput,
Group,
XAddress,
XButton,
Cell,
Selector
},
methods: {
recordlist() {
this.$router.push({name: 'recordlist', params: {data: this.data}})
},
bind() {
this.$router.push({name: 'smallbox', params: {order: this.data, role: this.role}})
},
repairs() {
this.$router.push({name: 'normalrepairs', params: {obj: this.data, isviwo: '是'}})
}
},
created() {
var openid = localStorage.getItem('openid')
const unionid = localStorage.getItem('unionid')
var that = this;
this.$http.get("api/v1/wechat/" + unionid).then(function (res) {



if (res.data.length) {
let account = res.data[0].account;
that.$http.post('api/v1/wechat/' + unionid + '/token', {'account': account})
.then(res => {
localStorage.setItem('token', res.data.token)
localStorage.setItem('userid', res.data.userid)
var opid = res.data.userid
var obj = {
headers: {
token: res.data.token,
opid: res.data.userid
}
}
that.$http.get('api/v1/accounts/' + res.data.userid, obj)
.then((response) => {
for (var i = 0; i < response.data.length; i++) {
if (response.data[i].type == 'INDV' || response.data[i].type == 'ENTP') {
that.role = response.data[i].type
break;
}
if (response.data[i].type == 'EXPT' || response.data[i].type == 'SRVP') {
that.isid = response.data[i].type
}
}

if (that.role == 'INDV' || that.role == 'ENTP') {

that.$http.get('api/v1/users/' + opid + '/devices', obj).then(res => {
var data = res.data.monitors
if (data.length !== 0) {
for (let i = 0; i < data.length; i++) {
if (data[i].seq == that.data.seq) {
that.flag = false
that.state = '已绑定'
that.statusflag = true
that.status = data[0].connected == 'YES' ? '正常' : '断开链接';
break;
} else {
if (data[i].devices.length !== 0) {
for (let j = 0; j < data[i].devices.length; j++) {
if (data[i].devices[j].hasOwnProperty('nodes')) {
for (let k = 0; k < data[i].devices[j].nodes.length; k++) {
if (data[i].devices[j].nodes[k].seq === that.data.seq && data[i].devices[j].nodes[k].bonded === 'YES') {
that.flag = false
that.state = '已绑定'
that.statusflag = true
switch (data[i].devices[j].nodes[k].status) {
case 'OK':
that.status = '正常';
break;
case 'WARN':
that.status = '警告';
break;
case 'ERROR':
that.status = '故障';
break;
case 'Disconnect':
that.status = '断开连接';
break;
}
break;
}
}
} else {
if (data[i].devices[j].node.seq == that.data.seq && data[i].devices[j].node.bonded === 'YES') {
that.flag = false
that.state = '已绑定'
that.statusflag = true
switch (data[i].devices[j].node.status) {
case 'OK':
that.status = '正常';
break;
case 'WARN':
that.status = '警告';
break;
case 'ERROR':
that.status = '故障';
break;
case 'Disconnect':
that.status = '断开连接';
break;
}
break;
}
}
}
}
}
}
} else {
that.flag = true
that.state = '未绑定'
}
}).catch(err => {
console.log(err)
})
}
})
.catch(function (error) {
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
}
})
})
.catch(function (error) {
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
}
})
} else {
that.flag = true;
that.state = '未绑定'
}
});
},
beforeRouteEnter: function (to, from, next) {
if (from.name !== 'normalrepairs') {
next(vm => {
AjaxPlugin.$http.get('/api/v1/devices/' + from.query.id + '/wechat?type=USER&role=INDV')
.then((response) => {
if (response.data) {
vm.data = response.data
localStorage.removeItem('history')
}
})
.catch((error) => {
vm.$vux.alert.show({
title: '',
content: '无法识别编码,请确定是否扫描云帷编码?',
})
vm.data = {}
})
})
} else {
next(vm => {
let obj = {}
obj.extname = vm.$route.params.extname
obj.sn = vm.$route.params.sn
obj.seq = vm.$route.params.seq
vm.data = obj
localStorage.removeItem('history')
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/sbxx.vue